import Swiper from './../../imports/import-swiper';

export default () => {
  const containers = document.querySelectorAll('.experience-img__slider');
  
  if (containers.length > 0) {
    containers.forEach((container, i) => {
      const slides = container.querySelectorAll(".swiper-slide");

      if (slides.length > 1) {
        const slider = new Swiper(container, {
          loop: true,
          speed: 700,
          touchStartPreventDefault: false,
          autoplay: {
            delay: 10000,
          },
          pagination: {
            el: container.querySelector('.experience-img__pagination'),
            type: 'bullets',
            clickable: true,
          },
        })
      }
      


    });
  }
}
